'use client'

import { getUser, useLogout } from '@/features/Auth/auth.hooks'
import { AppRoutes } from '@/routes'
import { usePathname } from 'next/navigation'
import { type ReactNode, useEffect, useState } from 'react'

function isExemptPath(pathname: string) {
  return pathname === AppRoutes.AUTH_SIGNIN || pathname.includes('pub') || pathname.includes('captcha')
}

export function AuthGuard({ children }: { children: ReactNode }): ReactNode {
  const { logout } = useLogout()
  const pathname = usePathname()
  const exempt = isExemptPath(pathname)
  const [ready, setReady] = useState(exempt)

  useEffect(() => {
    async function checkSession() {
      if (exempt) {
        setReady(true)
        return
      }

      if (!getUser()?.refreshToken) {
        await logout()
        return
      }

      setReady(true)
    }

    checkSession()
  }, [exempt, logout, pathname])

  if (!ready) return null

  return children
}
